// src/contexts/CalendarioContext.js
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import feriadoService from '../services/feriadoService';

const CalendarioContext = createContext();

export const CalendarioProvider = ({ children }) => {
    const [calendarioAbierto, setCalendarioAbierto] = useState(false);
    const [feriados, setFeriados] = useState([]);

    const cargarFeriados = useCallback(async () => {
        try {
            const response = await feriadoService.obtenerActivosActualesYFuturos();
            const data = Array.isArray(response.data) ? response.data : [];
            console.log('📅 CalendarioContext: Feriados cargados:', data.length, data[0]);
            setFeriados(data);
        } catch (error) {
            console.error('❌ CalendarioContext: Error feriados principal:', error?.response?.status, error?.message);
            try {
                const response = await feriadoService.obtenerActivos();
                const anioActual = new Date().getFullYear();
                const data = Array.isArray(response.data) ? response.data : [];
                const filtrados = data.filter(f => {
                    const fechaFeriado = new Date(f.fecha);
                    return fechaFeriado.getFullYear() >= anioActual;
                });
                console.log('📅 CalendarioContext: Feriados cargados (fallback):', filtrados.length);
                setFeriados(filtrados);
            } catch (fallbackError) {
                console.error('❌ CalendarioContext: Error feriados fallback:', fallbackError?.message);
            }
        }
    }, []);

    useEffect(() => {
        cargarFeriados();
    }, [cargarFeriados]);

    useEffect(() => {
        const interval = setInterval(() => {
            cargarFeriados();
        }, 60000);

        return () => clearInterval(interval);
    }, [cargarFeriados]);

    return (
        <CalendarioContext.Provider value={{ calendarioAbierto, setCalendarioAbierto, feriados, cargarFeriados }}>
            {children}
        </CalendarioContext.Provider>
    );
};

export const useCalendario = () => {
    const context = useContext(CalendarioContext);
    if (!context) {
        throw new Error('useCalendario debe usarse dentro de CalendarioProvider');
    }
    return context;
};
